import * as React from 'react';
import { AppBarComponent } from '@syncfusion/ej2-react-navigations';
import { useState } from 'react';
import { MessageComponent } from '@syncfusion/ej2-react-notifications';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { SupportedFilesTypesLine } from './types/formats';
import { IDocumentLoader } from './types/document';

interface IUnsupportedAppProps {
    documentLoader: IDocumentLoader;
}

function UnsupportedApp(props: IUnsupportedAppProps) {

    const [visible, setVisible] = useState<boolean>(true);
    const [cssClass, setCssClass] = useState<string>(
        'e-outline e-primary e-success msg-hidden'
    );
    
    const closed = () => {
        setCssClass('e-outline e-primary e-success');
    };

    const handleDownload = () => {
        var data = new Blob([new Uint8Array(props.documentLoader.document.body.data)]);
        var url = window.URL.createObjectURL(data);
        const tempLink = document.createElement('a');
        tempLink.href = url;
        tempLink.setAttribute('download', props.documentLoader.document.name + ' (v' + props.documentLoader.document.metadata.versionNumber.toString() + ')' + 
            props.documentLoader.document.metadata.file.ext);
        tempLink.click();
        window.URL.revokeObjectURL(url);
    }
    
    const contentTemplate = () => {
        return (
            <div>
                <h1>На жаль, цей формат не підтримується</h1>
                <p>Можливі формати файлів для перегляду та редагування наступні:  {SupportedFilesTypesLine}</p>
                <p>Ви можете скачати файл та редагувати його в сторонньому редакторі</p>
                { (props.documentLoader.document.access.allowDownload || props.documentLoader.document.access.allowRead || props.documentLoader.document.access.allowEdit) &&
                <div style={{ textAlign: "center" }}>
                    <ButtonComponent cssClass='e-link' onClick={() => {handleDownload()}}>Завантажити</ButtonComponent>
                </div>
                }
            </div>
        );
    };

    return (
        <React.Fragment>
            <div className="row" style={{ maxHeight: '40px', marginBottom: '20px' }}>
                <div className="col-md-12">
                    <AppBarComponent mode="Dense" colorMode="Primary">
                        <ButtonComponent 
                            //ref={denseBtn => (denseBtn = denseBtn)} 
                            aria-label='menu' 
                            cssClass='e-inherit menu' 
                            iconCss='e-icons e-menu'
                        ></ButtonComponent>
                        <span className="dense">{localStorage.getItem('appName')}</span>
                        <div className="e-appbar-spacer"></div>
                    </AppBarComponent>
                </div>
            </div>
                <div className="msg-template-section">
                    <div className="content-section">
                        <MessageComponent id="msg_template" visible={visible} content={contentTemplate} severity="Error" closed={closed} />
                    </div>
                </div>
        </React.Fragment>
    );
}
export default UnsupportedApp;